import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  IconButton,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { CloudUpload, Delete } from "@material-ui/icons";
import InfoPopover from "../../../../utils/informationButton";

const TeamPhotoResponseComponent = (props) => {
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isCorrectRatio, setIsCorrectRatio] = useState(true);

  // Vérifier s'il y a une image existante depuis le serveur
  const existingImageUrl = props.state.formDatas.teamPhotoFilter?.imageUrl;
  const existingFileName = props.state.formDatas.teamPhotoFilter?.fileName;
  const hasExistingImage =
    existingImageUrl && !props.state.formDatas.teamPhotoFilter?.fileDeleted;

  console.log(
    "------ props.state.formDatas.teamPhotoFilter ------",
    props.state.formDatas.teamPhotoFilter
  );

  // Initialiser l'état avec l'image existante si elle existe
  useEffect(() => {
    if (hasExistingImage && !selectedFile) {
      setPreviewUrl(existingImageUrl);
      setIsCorrectRatio(true); // On suppose que l'image existante est correcte
    }
  }, [hasExistingImage, existingImageUrl, selectedFile]);

  const checkImageRatio = (file) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const ratio = img.width / img.height;
        const targetRatio = 16 / 9;
        const isCorrect = ratio === targetRatio;
        console.log("ratio", ratio);
        console.log("targetRatio", targetRatio);
        console.log("isCorrect", isCorrect);
        resolve(isCorrect);
      };
      img.src = URL.createObjectURL(file);
    });
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === "image/png") {
      // Vérifier le ratio de l'image
      const correctRatio = await checkImageRatio(file);
      setIsCorrectRatio(correctRatio);

      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewUrl(e.target.result);
      };
      reader.readAsDataURL(file);

      // Appeler la fonction de mise à jour du parent si elle existe
      if (props.updateTeamPhotoFilter) {
        props.updateTeamPhotoFilter(file);
      }
    } else if (file) {
      alert(t("newEnigma.onlyPngAllowed"));
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setPreviewUrl(null);
    setIsCorrectRatio(true);
    if (props.updateTeamPhotoFilter) {
      props.updateTeamPhotoFilter(null);
    }
  };

  // Déterminer si on doit afficher le contenu d'upload ou la prévisualisation
  const shouldShowUpload = !selectedFile && !hasExistingImage;
  const shouldShowPreview = selectedFile || hasExistingImage;
  const displayFileName = selectedFile ? selectedFile.name : existingFileName;

  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <Typography variant="h6" className={props.classes.responseTitle}>
          {t("newEnigma.teamPhotoFilter")}
        </Typography>
        <InfoPopover
          title={t("newEnigma.teamPhotoFilter")}
          text={t("newEnigma.teamPhotoFilterInfo")}
          src="/images/photo-equipe-ex.png"
        />
      </Box>

      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
          marginBottom: "16px",
        }}
      >
        {shouldShowUpload ? (
          <>
            <Button
              variant="contained"
              color="primary"
              component="label"
              startIcon={<CloudUpload />}
              style={{
                marginBottom: "16px",
                textTransform: "none",
                fontSize: "16px",
                padding: "12px 24px",
              }}
            >
              {t("newEnigma.uploadPngFilter")}
              <input
                type="file"
                hidden
                accept=".png"
                onChange={handleFileSelect}
              />
            </Button>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ fontSize: "14px", textAlign: "center" }}
            >
              {t("newEnigma.uploadPngDescription")}
            </Typography>
          </>
        ) : (
          <Paper
            elevation={3}
            style={{
              width: "100%",
              maxWidth: "400px",
              padding: "16px",
              borderRadius: "8px",
            }}
          >
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "12px",
              }}
            >
              <Typography variant="subtitle1" style={{ fontWeight: "500" }}>
                {displayFileName}
              </Typography>
              <IconButton
                onClick={handleRemoveFile}
                size="small"
                style={{ color: "#f44336" }}
              >
                <Delete />
              </IconButton>
            </Box>

            {/* Message d'avertissement si le ratio n'est pas 16:9 (seulement pour les nouvelles images) */}
            {selectedFile && !isCorrectRatio && (
              <Typography
                variant="body2"
                style={{
                  color: "#ff9800",
                  textAlign: "center",
                  marginBottom: "12px",
                  fontWeight: "500",
                }}
              >
                ⚠️ {t("newEnigma.incorrectRatioWarning")}
              </Typography>
            )}

            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "12px",
                position: "relative",
              }}
            >
              {/* Image de fond photo-equipe.webp */}
              <img
                src="/images/photo-equipe.webp"
                alt="Photo équipe de base"
                style={{
                  maxWidth: "100%",
                  maxHeight: "200px",
                  borderRadius: "4px",
                  border: "1px solid #e0e0e0",
                }}
              />

              {/* Filtre PNG superposé avec les mêmes dimensions exactes */}
              {previewUrl && (
                <img
                  src={previewUrl}
                  alt="Filtre appliqué"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    maxWidth: "100%",
                    maxHeight: "200px",
                    borderRadius: "4px",
                    objectFit: "contain",
                  }}
                />
              )}
            </Box>

            <Typography
              variant="body2"
              color="textSecondary"
              style={{ textAlign: "center", fontSize: "12px" }}
            >
              {t("newEnigma.filterPreview")}
            </Typography>
          </Paper>
        )}
      </Box>

      <Typography
        variant="body2"
        color="textSecondary"
        style={{
          textAlign: "center",
          fontStyle: "italic",
          marginTop: "8px",
        }}
      >
        {t("newEnigma.teamPhotoOptional")}
      </Typography>

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "16px",
          padding: "16px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={props.state.formDatas.sendPhotoWhenGameEnded || false}
              onChange={props.updateSendPhotoWhenGameEnded}
              color="primary"
            />
          }
          label={t("newEnigma.sendPhotoWhenGameEnded")}
        />
        <InfoPopover
          title={t("newEnigma.sendPhotoWhenGameEnded")}
          text={t("newEnigma.sendPhotoWhenGameEndedInfo")}
        />
      </Box>
    </>
  );
};

export default TeamPhotoResponseComponent;
